// RoomStatusDialog.jsx
import React from "react";
import {
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import styles from "../../../styles.module.css";
import clsx from "clsx";

import { getReadableTextColor } from "@thequantumhub/iam-package";

const RoomStatusDialog = ({ open, onClose, onSelect, currentStatus }) => {
  const statuses = [
    { name: "Vacant", color: "#00FFFD" },
    { name: "Visitors Welcome", color: "#0BCE40" },
    { name: "No Visitors", color: "#FE0300" },
    { name: "Quiet Time", color: "#0F61AA" },
    { name: "Patient Out of Room", color: "#ECEF1F" },
    { name: "EVS TRANSIT", color: "#F3BA22" },
    { name: "EVS STAT", color: "black" },
  ];

  return (
    <Dialog
      onClose={onClose}
      open={open}
      className={clsx(`${styles.flexCenter}`)}
    >
      <DialogTitle>Select Room Status</DialogTitle>
      <List
        className={clsx(`${styles.flexColumnCenter} ${styles.roomStatusList}`)}
        style={{ width: "400px" }}
      >
        {statuses.map((status) => (
          <ListItem
            button
            key={status.name}
            onClick={() => onSelect(status.name)}
            style={{ backgroundColor: status.color }}
            className={styles.roomStatusDialogListItem}
          >
            <ListItemText
              primary={status.name}
              style={{
                cursor: "pointer",
                color: getReadableTextColor(status.color),
                borderRadius: "20px",
                textAlign: "center",
              }}
            />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
};

export default RoomStatusDialog;
